
export default {
    props: {
        categoryPadding:{
            type: String,
            default: ''
        },
        overflow:{
            type: String,
            default: 'overflow-hidden'
        },

        rentalClass:{
            type: String,
            default: 'rentals'
        },
        vloader: {
            type: Boolean,
            default: false
        },
        samePage:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            quantity: 1,
            btnId: null,
            allVehicleData: null,
        }
    },
    mounted() {
        this.getAllVehicleData()
    },
    methods: {
        setFallbackImageUrl(event) {
            event.target.src = require(`@/assets/img/placeholders/thumbnail-square.svg`)
        },
        getDeals(vehicleData) {
            let val = {
                quantity: this.quantity,
                id: vehicleData && vehicleData.vehicle ? vehicleData.vehicle._id : null
            }
            this.$emit("getDealsClicked", val);
        },
        async getAllVehicleData() {
            this.allVehicleData = await fetch(this.$config.fetchUrl + '/api/rentals/v2/getPopularVehicles').then(
                res => res.text());
            this.allVehicleData = this.getCryptKey(this.allVehicleData);
        },
        offerPercentage(strikePrice, price) {
            if (strikePrice > price) {
                let offerPercentage = strikePrice - price;
                if (offerPercentage > 0) {
                    return ((100 * (strikePrice - price) / strikePrice) > 0 && (100 * (strikePrice - price) /
                        strikePrice) < 100) ? parseFloat((100 * (strikePrice - price) / strikePrice).toFixed(0)) : 0
                } else return 0
            }
            return 0
        },
        samePageClick(){
            this.$emit('samePageClicked', true)
        }
    }
}

